import React, { useCallback, useContext, useReducer } from 'react';

export const initialState = {
  completed: [
    false, // FMAssignment
    false, // FundingSource
    false, // AMFIProducts
    false, // DealDetails
    false, // ReviewSpotInstructions
    false // DealCompletionChecklist
  ],
  currentNumber: 1
};

export const dealReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'UPDATE_AMFI':
      return {
        ...state,
        isAMFI: payload.isAMFI
      };
    case 'UPDATE_COMPLETED':
      const { number, complete } = payload;
      const completed = state.completed.slice(0);
      completed[number - 1] = complete;
      return {
        ...state,
        completed,
        currentNumber: completed.findIndex(c => !c) + 1 || 0
      };
    default:
      return state;
  }
};

const DetailProvider = React.createContext(null);

export default function DealProvider({ children }) {
  const [state, dispatch] = useReducer(dealReducer, initialState);

  const isDisabled = number => state.currentNumber && number > state.currentNumber;

  const setAMFI = useCallback(isAMFI => {
    dispatch({ type: 'UPDATE_AMFI', payload: { isAMFI } });
  }, []);
  const setCompleted = useCallback((number, complete) => {
    dispatch({ type: 'UPDATE_COMPLETED', payload: { number, complete } });
  }, []);

  return (
    <DetailProvider.Provider
      value={{
        ...state,
        setAMFI,
        setCompleted,
        isDisabled
      }}
    >
      {React.Children.only(children)}
    </DetailProvider.Provider>
  );
}

// HOOK
export const useDetail = () => useContext(DetailProvider);
